import Vue from 'vue'
import Vuex, {StoreOptions} from 'vuex'
import Order from "@/logic/model/Order";
import Category from "@/logic/model/Category";
import OrderItem from "@/logic/model/OrderItem";
import User from "@/logic/model/User";
import ApiConnector from "@/logic/connector/ApiConnector";
import OrderRepository from '@/logic/repository/OrderRepository';
import CategoryRepository from '@/logic/repository/CategoryRepository';

Vue.use(Vuex);

interface RootState {
    order: Order;
    categories: Array<Category>;
    user : User;
    isArticlesLoading:boolean;
    isOrdersLoading:boolean;
}

const store: StoreOptions<RootState> = {
    state: {
        order: new Order(new Date(),false,[]),
        categories: [],
        user: new ApiConnector().getUser(),
        isArticlesLoading:false,
        isOrdersLoading:false,
    },
    mutations: {
        addOrderItem(state,orderItem:OrderItem) {
            if (state.order.$orderItems.includes(orderItem) === false) {
                state.order.addOrderItem(orderItem)
            }
        },
        setCategories(state,categories:Array<Category>) {
          state.categories = categories
        },
        setUser(state,user:User) {
            state.user = user;
        },
        setOrder(state,order:Order) {
            state.order = order;
        },
        removeOrderItem(state,orderItem:OrderItem) {
            state.order.removeItem(orderItem);
        },
        updateOrderItem(state,orderItem:OrderItem) {
            state.order.updateItem(orderItem);
        },
        confirmOrder(state) {
            state.order.$orderConfirmed = true
        },
        SET_LOADING(state,{type,value}) {
            if (type.toLowerCase() === "articles") {
                state.isArticlesLoading = value
            } else if (type.toLowerCase() === "orders") {
                state.isOrdersLoading = value
            }
        }
    },

    actions: {
        fetchData({commit}) {
            commit("SET_LOADING",{type:"articles",value:true});
        new CategoryRepository().getAll().then((categories:Array<Category>) => {

            setTimeout(() => {
                commit("SET_LOADING",{type:"articles",value:false});
            },1000);
            commit("setCategories",categories);

        });
        commit("SET_LOADING",{type:"orders",value:true});
        new OrderRepository().getCart().then( (order:Order) => {
            setTimeout(() => {
                commit("SET_LOADING",{type:"orders",value:false});
            },1000);

            commit('setOrder',order);
        });
        }
    }

};

export default new Vuex.Store<RootState>(store);
